export const DEFAULT_VIEW = 'DEFAULT';
export const ELECTROSTATIC_VIEW = 'ELECTROSTATIC';
export const SHAPE_VIEW = 'SHAPE';
export const HBOND_VIEW = 'HBOND';

export const DEFAULT_BUTTON = 'default';
export const ELECTROSTATIC_BUTTON = 'electrostatic';
export const SHAPE_BUTTON = 'shape';
export const HBOND_BUTTON = 'hbond';